import React, { Dispatch, SetStateAction } from 'react'
// Local
import Icon from './icon'
import ChevronDown from '../icons/chevronDown'
import { EncounterConditionDisplayModified } from '../authenticated/types'
import { shouldRenderReskin2025 } from '../../constant'

type Props = {
  description: string
  isAddressed?: boolean
  isRequired: boolean
  isDescriptionShowing: boolean
  setIsDescriptionShowing?: Dispatch<SetStateAction<boolean>>
  // eslint-disable-next-line react/no-unused-prop-types
  condition?: EncounterConditionDisplayModified
}

function Title(props: Props): JSX.Element {
  const {
    description,
    isAddressed,
    isRequired,
    isDescriptionShowing,
    setIsDescriptionShowing
  } = props

  function onClick(): void {
    if (setIsDescriptionShowing) setIsDescriptionShowing(!isDescriptionShowing)
  }

  return (
    <div className="title-container" onClick={ onClick }>
      <div className={ `title${shouldRenderReskin2025 ? ' reskin': '' }` }>
        <Icon
          isAddressed={ isAddressed }
          isRequired={ isRequired }
        />
        <div className="title-text">{ description.replace('Suspect: ', '') }</div>
      </div>
      <div
        className={ `chevron-container is-${
          isDescriptionShowing ? 'down' : 'up'
        }` }
      >
        <ChevronDown />
      </div>
    </div>
  )
}

export default Title
